import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';
import { theme } from '../../../theme'

const StyledLink = styled(Link)`
 display: flex;
 align-items:center;
 padding: 11px 26px;
//  border-top: 1px solid #D8D8D8;
 border-bottom: 1px solid #D8D8D8;
 z-index: 10;
 position: relative;

 .label {
     margin-left: 1.2rem;
     font-weight: 700;
     font-size: 1.4rem;
     color: #979797;
     white-space: nowrap;
    opacity: ${(p) => Number(!p.compact)};
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
 }

    .icon-container {
        opacity: 1;
    }

 &:hover {
    .label {
        color: ${theme.colors.mainBlue};
    }

    .icon-container {
        color: ${theme.colors.mainBlue};
    }
 }

 &.active{
    background-color: ${theme.colors.lightBlue};
    box-shadow: inset 2px 0px 0px #3359DF;
    
    .label, .icon-container {
        color: ${theme.colors.mainBlue};
    }
  }

 @media(max-width: 920px) {
    .label {
        opacity: 1;
    }
    
  );
`;

const ToolTip = styled.span`
    position: absolute;
    left: 12.2rem;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0.6rem;
    height: 3.5rem;
    width: 12.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // text-align: center;
    background-color: ${theme.colors.grey01};
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.2);
    transition: 0s;
    opacity: 0;
    pointer-events: none;
    // margin-top: -4rem;
    // margin-left: 6rem;
    font-size: 1.2rem;
`;

const LinkContainer = styled.div`
    position: relative;
    cursor: pointer;

    &::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 3px;
        background-color: ${theme.colors.lightBlue};
        transform: scaleY(0);
        transition: transform .1s,
                    width .2s cubic-bezier(1,0,0,1) .1s
        ;
        box-shadow: inset 2px 0px 0px #3359DF;
    }

    &:hover::before {
        transform: scaleY(1);
        width: 100%;
         }
        
    //     ${ToolTip} {
    //         transiton: all 0.5s ease;
    //         opacity: 1;
    //         // top: 50%;
    //      }
     }


`;

const IconContainer = styled.div`
    width: 24px;
    height: 24px; 
    color: ${theme.colors.navLinkColorDefault};
    opacity: 1;
    svg {
        height: 24px;
        width: 24px;
    }
`;



const NavLink = ({ children, icon, label, link, toggleNav, compact, ...rest }) => {
    return (
        <LinkContainer>
            <StyledLink to={link} onClick={toggleNav} compact={compact} {...rest}>
                {children || (

                    <>
                        <IconContainer className="icon-container">
                            {icon}
                        </IconContainer>

                        {/* <img src={icon} alt={`${label}-icon`} /> */}
                        <div className="label"><span>{label}</span></div>

                    </>
                )}

            </StyledLink>
            {/* <ToolTip>{label}</ToolTip> */}
        </LinkContainer>
    )
}

export default NavLink
